import React from 'react';
import {ColorClear, ColorTitle} from 'src/styles/Colors';
import {FontWeightMedium} from 'src/res/FontWeight';
import TouchableOpacity from "../commons/TouchableOpacity";
import View from "../commons/View";
import AppText from "../commons/AppText";
import ImageBackground1 from "../commons/ImageBackground1";
import {BORDER_RADIUS} from "src/styles/Styles";
import {colorWithAlpha} from "src/js/utils/AppUtils";

export default class QuestionOptionItem extends React.PureComponent {

  onClick = () => {
    this.props.onClick(this.props.id);
  };

  render() {
    const {uiConfigs, bgImage} = this.props;
    const titleColor = this.props.titleColor || ColorTitle;
    const selectorColor = this.props.selectorColor || ColorTitle;
    const marginLeft = uiConfigs.isLTR ? 10 * uiConfigs.sizeFactor : 6 * uiConfigs.sizeFactor;
    const marginRight = uiConfigs.isLTR ? 6 * uiConfigs.sizeFactor : 10 * uiConfigs.sizeFactor;
    const marginDotRight = uiConfigs.isLTR ? 8 * uiConfigs.sizeFactor : 0;
    const marginDotLeft = uiConfigs.isLTR ? 0 : 8 * uiConfigs.sizeFactor;

    const view = (
      <View
        style={{
          position: 'relative',
          minHeight: 28 * uiConfigs.sizeFactor,
          marginLeft: marginLeft,
          marginRight: marginRight,
          marginTop: 8,
          marginBottom: 12,
          flexDirection: 'row',
          flex: 1,
          alignItems: 'center',
          ...this.props.styleWrapper
        }}>
        <View
          style={{
            width: 16,
            height: 16,
            borderRadius: 8,
            borderWidth: 2,
            borderColor: selectorColor,
            borderStyle: 'solid',
            marginLeft: marginDotLeft,
            marginRight: marginDotRight,
          }}>
          <View
            style={{
              margin: 2,
              width: 8,
              height: 8,
              borderRadius: 4,
              backgroundColor: this.props.selected ? selectorColor : ColorClear,
            }} />
        </View>
        <AppText
          variant={'body2'}
          fontSizeN={uiConfigs.fontSize}
          align={'left'}
          style={{
            fontWeight: FontWeightMedium,
            color: titleColor
          }}>
          {this.props.name}
        </AppText>
      </View>
    );
    let viewWrapper = null;
    if (bgImage) {
      viewWrapper = (
        <ImageBackground1 source={bgImage} resizeMode="fill" style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, width: '100%'}} >
          {view}
        </ImageBackground1>
      );
    } else {
      viewWrapper = (
        <div style={{width: '100%', backgroundColor: colorWithAlpha(uiConfigs.messageBgColor, 0.96), borderColor: uiConfigs.messageBorderColor, borderWidth: 1, borderRadius: BORDER_RADIUS, borderStyle: 'solid'}}>
          {view}
        </div>
      );
    }

    return (
      <TouchableOpacity
        onClick={this.onClick}
        disabled={this.props.disabled}
        style={{
          width: '100%',
          position: 'relative',
          marginTop: 4,
          opacity: this.props.disabled ? 0.8 : 1,
        }}>
        {viewWrapper}
      </TouchableOpacity>
    );
  }
}

